export default "__VITE_PUBLIC_ASSET__8bd83876__"